import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, RecipientActionCreators, ICenterRecipientListResponse, IRecipientSearchRequest } from '@nkr/store/index';
import { IRecipientForList, IRecipient } from '@nkr/models/index';
import Search from './search';
import Grid from './grid';
import RecipientsNav from '../../tabs';

interface IProps {
}

interface IStateProps {
    groupIsSuper: boolean
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void
    getList: (request: IRecipientSearchRequest) => Promise<ICenterRecipientListResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    list: IRecipientForList[],
    alias: string,
    statusList: string[],
    typeList: string[],
    voucherType: string
}

class RecipientList extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        alias: '',
        statusList: ['active', 'inactive'],
        typeList: ['direct', 'paired', 'voucher', 'wlp'],
        voucherType: ''
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let { statusList, typeList, voucherType, alias } = this.state;

        let request: IRecipientSearchRequest = {
            centerId: 0,
            statusList,
            typeList,
            voucherType,
            alias,
            firstName: '',
            lastName: '',
            email: ''
        };

        this.props.showLoading('Getting recipients, one moment please...').then(() => {
            this.props.getList(request).then(response => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleAliasChange = (alias: string) => {
        this.setState({
            alias
        });
    }

    handleStatusListChange = (statusList: string[]) => {
        this.setState({
            statusList
        });
    }

    handleTypeListChange = (typeList: string[]) => {
        this.setState({
            typeList
        });
    }

    handleSearch = () => {
        this.getData();
    }

    render = () => {
        return (
            <div style={{ padding: '0px 10px' }}>
                <RecipientsNav activeKey={'RECIPIENT-LIST'} centerId={0} recipientAlias={''} hasRecipientShield={false} isAdmin={true} onTabSelect={() => null} />

                <div style={{ padding: 10, border: '1px solid #ccc', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                    <Search
                        alias={this.state.alias}
                        statusList={this.state.statusList}
                        typeList={this.state.typeList}
                        onAliasChange={this.handleAliasChange}
                        onStatusListChange={this.handleStatusListChange}
                        onTypeListChange={this.handleTypeListChange}
                        onSearch={this.handleSearch}
                    />

                    <Grid
                        centerId={0}
                        data={this.state.list}
                        centerHasRecipientShield={true} />

                    <div>{this.state.list.length} recipient(s)</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IProps): IStateProps => {
    return {
        // center: appState.app.center,
        groupIsSuper: appState.app.user.group.isSuper
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getList: (request) => {
            return dispatch(RecipientActionCreators.getList(request, true));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(RecipientList);

